<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery" :filters="false">
        <template slot="btns" v-if="permission('/community/hot/add')">
            <el-button size="mini" icon="el-icon-plus" type="primary" @click="handleAdd">
                新增热词
            </el-button>
        </template>
        <template slot="columns">
            <el-table-column type="index" label="序号" width="100" align="center" />
            <el-table-column label="热词" align="center" prop="word"></el-table-column>
            <el-table-column label="添加时间" align="center" prop="createTime"></el-table-column>
            <el-table-column label="权重" align="center" prop="weight"></el-table-column>
            <el-table-column label="操作" align="center" width="180" v-if="permission('/community/hot/edit') || permission('/community/hot/delete') || permission('/community/hot/weight')">
                <template slot-scope="{ row }">
                    <el-link v-if="permission('/community/hot/edit')" :underline="false" type="primary" @click="handleEdit(row)">编辑</el-link>
                    <el-link v-if="permission('/community/hot/delete')" :underline="false" type="danger" @click="handleDelete(row)">删除</el-link>
                    <el-link v-if="permission('/community/hot/weight')" :underline="false" type="primary" @click="handleSetWeight(row)">设置权重</el-link>
                </template>
            </el-table-column>
        </template>
        <el-dialog title="设置权重" :visible.sync="weightVisible" width="500px">
            <el-form :model="weightForm" ref="weightForm" :rules="weightRules" label-width="60px">
                <el-form-item label="权重" prop="weight">
                    <el-input v-model="weightForm.weight" placeholder="请输入权重" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="weightVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSetWeightConfirm">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="mode === 'edit' ? '编辑热词' : '新增热词'" :visible.sync="visible" width="500px">
            <el-form :model="form" ref="form" :rules="rules" label-width="60px">
                <el-form-item label="热词" prop="word">
                    <el-input v-model="form.word" placeholder="请输入热词" />
                </el-form-item>
                <el-form-item label="权重" prop="weight">
                    <el-input v-model="form.weight" placeholder="请输入权重" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="handleConfirm">确 定</el-button>
            </div>
        </el-dialog>
    </ListPage>
</template>

<script>
import { page, add, edit, del } from "@/api/community/hot";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                word: "",
            },
            weightVisible: false,
            visible: false,
            mode: 'add',
            form: {
                word: '',
                weight: '',
            },
            weightForm: {
                weight: '',
            },
            rules: {
                word: [{ required: true, message: '请输入热词' }],
                weight: [{ required: true, message: '请输入权重' }],
            },
            weightRules: {
                weight: [{ required: true, message: '请输入权重' }],
            },
        };
    },
    mixins: [listMixin],
    mounted() {

    },
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
            };
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleAdd() {
            this.mode = 'add';
            this.form = {
                word: '',
                weight: '',
            };
            this.visible = true;
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        handleEdit(row) {
            this.mode = 'edit';
            this.visible = true;
            this.form = { ...row };
        },
        handleSetWeight(row) {
            this.weightVisible = true;
            this.weightForm = { ...row };
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                if (this.mode === 'edit') {
                    edit(this.form).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success('保存成功');
                            this.visible = false;
                            this.search();
                        } else {
                            this.$message.error(message);
                        }
                    });
                } else {
                    add(this.form).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success('保存成功');
                            this.visible = false;
                            this.search();
                        } else {
                            this.$message.error(message);
                        }
                    });
                }
            });
        },
        handleSetWeightConfirm() {
            this.$refs.weightForm.validate((valid) => {
                if (!valid) return;
                edit(this.weightForm).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('保存成功');
                        this.weightVisible = false;
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                });
            });
        },
        handleDelete(row) {
            this.$confirm("确定删除该热词吗？", "提示", { type: "warning" }).then(() => {
                del({ id: row.id }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('删除成功');
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                });
            }).catch(() => { });
        }
    },
};
</script>